import React from "react";
import { Layout } from "~/templates/Layout";
import { HubSpotEmbedForm } from "~/molecules/HubSpotEmbedForm";
import { colors } from "~/utils/colors";
import { PATH } from "~/constant/path";

const PARTNER_FORM_ID = "00df13f0-c1d2-4248-9e28-726452815eb2";

const PartnerApplicationPage: React.FC = () => {
  return (
    <>
      <style jsx>{`
        .wrapper {
          background-color: ${colors.white};
          padding: 10px 0 80px;
        }
        .container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 10px;
        }
        .title {
          font-size: 32px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
          color: ${colors.defaultText};
        }
        .description {
          font-size: 16px;
          line-height: 1.8;
          text-align: center;
          margin-bottom: 40px;
          color: ${colors.defaultText};
        }
        .form-container {
          margin: 0 auto;
          max-width: 700px;
          /* CLS 改善: フォーム読み込み前のスペースを確保（パートナー応募） */
          min-height: 550px;
        }
        .form-container :global(.hubspot-form) {
          min-height: 500px;
        }
        .form-container :global(.hs-form-html) {
          min-height: 480px;
        }
      `}</style>
      <Layout
        title="Refcome販売パートナー応募フォーム"
        ogpDescription="Refcomeの販売パートナーに応募いただけます。"
        breadCrumbItems={[PATH.TOP, PATH.PARTNER_APPLICATION]}
      >
        <div className="wrapper">
          <div className="container">
            <h1 className="title">販売パートナー応募フォーム</h1>
            <div className="form-container" data-hubspot-form-scroll-anchor>
              <HubSpotEmbedForm defaultFormId={PARTNER_FORM_ID} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default PartnerApplicationPage;
